import { BRAND } from '@/lib/cms/config';

export const ERROR_BRAND_CONFIG = {
  gallet: {
    name: 'Gallet',
    email: 'info.eu@gallet.com',
    website: 'gallet.com',
    logoSrc: '/logos/vertical_regular.svg',
    bgColor: '#3E4827',
    accentColor: '#C87F0A',
  },
  breitling: {
    name: 'Breitling',
    email: 'info@breitling.com',
    website: 'breitling.com',
    logoSrc: '/images/breitling/breitling-simple.svg',
    bgColor: '#090919',
    accentColor: '#FFC72C',
  },
  ug: {
    name: 'Universal Genève',
    email: 'info@universalgeneve.com',
    website: 'universalgeneve.com',
    logoSrc: '/logos/ug/horizontal_regular.svg',
    bgColor: '#14314b',
    accentColor: '#d13c0a',
  },
} as const;

export const errorBrandConfig = ERROR_BRAND_CONFIG[BRAND];
